import { NavLink, useNavigate } from "react-router";
import { ArrowLeft } from "lucide-react";

interface BackButtonProps {
  to?: string;
  label: string;
}

export default function BackButton({ to, label }: BackButtonProps) {
  const navigate = useNavigate();

  if (!to) {
    return (
      <div className="pb-1">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-sm font-medium text-gray-600 transition-colors hover:text-gray-800"
        >
          <ArrowLeft className="h-4 w-4" />
          {label}
        </button>
      </div>
    );
  }

  return (
    <div className="pb-1">
      <NavLink
        to={to}
        className="flex items-center gap-2 text-sm font-medium text-gray-600 transition-colors hover:text-gray-800"
      >
        <ArrowLeft className="h-4 w-4" />
        {label}
      </NavLink>
    </div>
  );
}
